<template>
  <z-card
    class="zoox-component zoox-notification-center"
    width="300"
    :height="cardHeight"
    :title="title"
    :class="{
      opened: opened && variant === 'card',
      'is-card': variant === 'card',
    }"
  >
    <template #actions>
      <z-icon
        class="zoox-notification-center-close"
        @click="$emit('click:close')"
      >
        {{ closeIcon }}
      </z-icon>
    </template>

    <template #content>
      <div
        style="height: calc(100% - 30px)"
        class="d-flex flex-column justify-space-between"
      >
        <z-scrollbar
          class="zoox-notification-center-content"
          :options="{suppressScrollX: true}"
        >
          <template v-if="notifications.length > 0">
            <template v-for="(notification, index) of notifications">
              <div
                :key="index"
                class="zoox-notification-center-item"
                tabindex="0"
                @keydown.enter.self="$emit('click:notification', notification)"
                @click="$emit('click:notification', notification)"
              >
                <div class="body3">
                  <slot name="notification" :notification="notification">
                    {{ notification.text }}
                  </slot>
                </div>
                <z-icon
                  class="zoox-notification-center-item-remove"
                  @click="$emit('click:remove', notification, $event)"
                >
                  {{ closeIcon }}</z-icon
                >
              </div>
            </template>
          </template>
          <template v-else>
            <div class="empty-text d-flex align-center">
              <span>{{ $t('no_current_alerts') }}</span>
              <z-icon size="20"> $notifications_none_rounded </z-icon>
            </div>
          </template>
        </z-scrollbar>

        <div class="zoox-notification-center-actions">
          <z-btn
            class="zoox-notification-center-readed"
            small
            primary
            :text="$t('mark_all_as_readed')"
            :disabled="notifications.length === 0"
            @click="$emit('click:readed')"
          />
          <z-btn
            class="zoox-notification-center-clear"
            small
            :text="$t('delete_readed_notifications')"
            :disabled="notifications.length === 0"
            @click="$emit('click:clear')"
          />
        </div>
      </div>
    </template>
  </z-card>
</template>

<script>
export default {
  props: {
    /**
     * Título do card das notificações
     */
    title: {
      type: String,
    },
    /**
     * Flag para indicar que está aberto
     */
    opened: {
      type: Boolean,
      default: false,
    },
    /**
     * Array de notificações a serem exibidas
     *
     * @typedef {text: string}
     */
    notifications: {
      type: Array,
      default: () => [],
    },
    /**
     * Define o ícone de remoção da notificação
     */
    closeIcon: {
      type: String,
      default: '$close_rounded',
    },
    /**
     * Define o tipo de card
     *
     * @values card, menu
     */
    variant: {
      type: String,
      default: 'card',
    },

    /**
     * Define a altura do card
     */
    cardHeight: {
      type: [String, Number],
      default: '',
    },
  },

  i18n: {
    messages: {
      pt: {
        delete_readed_notifications: 'Excluir notificações lidas',
        mark_all_as_readed: 'Marcar todas como lidas',
        no_current_alerts: 'Nenhum alerta atualmente',
      },
      es: {
        delete_readed_notifications: 'Eliminar todas las notificaciones',
        mark_all_as_readed: 'Mark all as read',
        no_current_alerts: 'No hay alertas actuales',
      },
      en: {
        delete_readed_notifications: 'Delete readed notifications',
        mark_all_as_readed: 'Mark all as read',
        no_current_alerts: 'No current alerts',
      },
      fr: {
        delete_readed_notifications: 'Supprimer les notifications lues',
        mark_all_as_readed: 'Marquer tout comme lu',
        no_current_alerts: "Pas d'alerte actuelle",
      },
      tr: {
        delete_readed_notifications: 'Okunmuş bildirimleri sil',
        mark_all_as_readed: 'Tümünü okundu olarak işaretle',
        no_current_alerts: 'Mevcut bildirim yok',
      },
    },
  },
}
</script>

<style scoped lang="scss">
.zoox-notification-center {
  &.is-card {
    height: 100vh;
    position: fixed;
    z-index: 10;
    right: -310px;
    top: 64px;
    max-height: calc(90% - 64px);
    transition: transform 300ms linear, opacity 300ms linear;
    opacity: 0;
  }

  &.opened {
    transform: translateX(-335px);
    opacity: 1;
  }

  .zoox-notification-center-content {
    display: flex;
    gap: 8px;
    flex-direction: column;
    padding: 16px 12px;
    height: calc(100% - 85px);

    .empty-text {
      display: flex;
      height: 100%;
      text-align: center;
      justify-content: center;
      font-size: 13px;
      font-weight: 400;
      line-height: 15px;
      color: var(--black-600);
    }
  }

  .zoox-notification-center-item {
    height: auto;
    display: grid;
    grid-template-columns: 1fr auto;
    column-gap: 8px;
    place-items: center;
    background: var(--background);
    border-radius: var(--component-card-radius);
    padding: 8px;
    cursor: pointer;
  }

  .zoox-notification-center-actions {
    display: flex;
    flex-direction: column;
    gap: 8px;

    > * {
      width: 100%;
    }
  }
}
</style>
